import React, { Component, Fragment } from 'react'
import { Dropdown, Row, Col, Button, OverlayTrigger, Tooltip } from "react-bootstrap";

import { Link } from "react-router-dom";
import { IoIosArrowBack } from "react-icons/io";

// services
import { CountryService } from "app/_services/ConfigService/CountryService/CountryService";
import { ProjectService } from "app/_services/ProjectService/ProjectService";

// custom
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import LogHistory from "app/views/custom/components/Logs/LogHistory";
import BackBtn from 'app/Components/CommanComponents/BackBtn';

export class ViewCountry extends Component {
    constructor(props) {
        super(props)

        this.state = {
            // projectId: this.props.match.params.projectId ? this.props.match.params.projectId : "",
            viewId: this.props.match.params.id ? this.props.match.params.id : "",
            // projectData: {},
            viewData: {},
        }
    }

    componentDidMount() {
        // this.setProjectDetails();
        this.viewData();
    }

    /*******************Api Call *******************/
    // setProjectDetails = async () => {
    //     let response = await ProjectService.projectDetailsByID(this.state.projectId);

    //     if (response && response.status) {
    //         if (response.data && response.data) {
    //             this.setState({
    //                 projectData: response.data
    //             })
    //         }
    //     }
    // }

    viewData = async () => {
        let response = await CountryService.getCountryByID(this.state.projectId, this.state.viewId);
        if (response && response.status) {
            if (response.data && response.data) {
                this.setState({
                    viewData: response.data
                })
            }
        }
    }

    showStatus = (activeStatus) => {
        let text = '';
        if (activeStatus === 1) {
            text = 'Active';
        } else if (activeStatus === 2) {
            text = 'In-Active';
        }
        return text
    }

    render() {
        const { projectId, projectData } = this.state;

        return (
            <div>
                <MainBreadcrumb
                    routeSegments={[
                        // { name: this.state.projectData.name ? this.state.projectData.name : '', path: "/project/" + this.state.projectId + "/dashboard" },
                        // { name: "Configuration", path: "#" },
                        { name: "Global Settings", path: "#" },
                        { name: "Country", path: "/global-configuration/project-details/country" },
                        { name: 'View' }
                    ]}
                    // imageSrc={this.state.projectData.document && Object.keys(this.state.projectData.document).length > 0 ? this.state.projectData.document.document_name : ''}
                    // description={this.state.projectData.descriptionDisplay ? this.state.projectData.descriptionDisplay : ''}
                    breadCrumbsText="Configuration_Project_Details_Country"
                />

                {this.state.viewData && Object.keys(this.state.viewData).length > 0 &&
                    <Fragment>
                        <div className="row d-flex justify-content-center">
                            <div className="col-md-12">
                                <div className="card mt-4 mb-3">
                                    <div className="card-body">
                                        <div className="simple-card-title">
                                            <h3 class="text-capitalize mb-1">View Country</h3>
                                            
                                            <BackBtn url="/global-configuration/project-details/country"/>
                                        </div>
                                        <div className="addressSmlSec" style={{ paddinTop: '0', borderTop: '0' }}>
                                            <Row>
                                                <Col md={3} className="drilingView-bx">
                                                    <h5>Country</h5>
                                                    <p>{this.state.viewData.name}</p>
                                                </Col>
                                                <Col md={3} className="drilingView-bx">
                                                    <h5>Status</h5>
                                                    <p>{this.state.viewData.activeStatus == 1 ? 'Active' : this.state.viewData.activeStatus == 2 ? 'In-Active' : ""}</p>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <LogHistory
                            subModulename={'country-master'}
                            projectId={this.state.projectId}
                            refrenceId={this.state.viewId}
                        ></LogHistory>
                    </Fragment>
                }

            </div>
        )
    }
}

export default ViewCountry


